import { useIs2xResolution } from "./support/use-is-2x-resolution.js";
import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-trash.tsx
/**
* icon.24.trash
*
* Keywords: delete, bin, waste, remove, discard, garbage, disposal, container
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE2LjM1NSA5YS41LjUgMCAwIDEgLjQ5OC41MmwtLjI3MyA2LjU2My0uMDE4LjE5OGEyIDIgMCAwIDEtMS43ODIgMS43MWwtLjE5OC4wMDlIOS40MThhMiAyIDAgMCAxLTEuOTk4LTEuOTE3bC0uMjczLTYuNTYyYS41LjUgMCAxIDEgMS0uMDQybC4yNzIgNi41NjNhMSAxIDAgMCAwIC45OTkuOTU4aDUuMTY0YTEgMSAwIDAgMCAxLS45NThsLjI3Mi02LjU2M2EuNS41IDAgMCAxIC41LS40NzlNMTEgMTBhLjUuNSAwIDAgMSAuNS41djRhLjUuNSAwIDAgMS0xIDB2LTRhLjUuNSAwIDAgMSAuNS0uNW0yIDBhLjUuNSAwIDAgMSAuNS41djRhLjUuNSAwIDAgMS0xIDB2LTRhLjUuNSAwIDAgMSAuNS0uNW0wLTVhMSAxIDAgMCAxIDEgMXYxaDMuNWEuNS41IDAgMCAxIDAgMWgtMTFhLjUuNSAwIDAgMSAwLTFIMTBWNmExIDEgMCAwIDEgMS0xem0tMiAyaDJWNmgtMnoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-11103
*/
const Icon24Trash = memo(function Icon24Trash(props) {
	return useIs2xResolution() ? /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.355 9a.5.5 0 0 1 .498.52l-.273 6.563-.018.198a2 2 0 0 1-1.782 1.71l-.198.009H9.418a2 2 0 0 1-1.998-1.917l-.273-6.562a.5.5 0 1 1 1-.042l.272 6.563a1 1 0 0 0 .999.958h5.164a1 1 0 0 0 1-.958l.272-6.563a.5.5 0 0 1 .5-.479M11 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5m2 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5m0-5a1 1 0 0 1 1 1v1h3.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1H10V6a1 1 0 0 1 1-1zm-2 2h2V6h-2z"
		})
	}) : /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M16.354 9a.5.5 0 0 1 .5.52l-.274 6.563-.018.198a2 2 0 0 1-1.782 1.71l-.198.009H9.418a2 2 0 0 1-1.998-1.917l-.274-6.562a.5.5 0 0 1 1-.042l.273 6.563a1 1 0 0 0 .999.958h5.164a1 1 0 0 0 1-.958l.271-6.563a.5.5 0 0 1 .5-.479M10.5 10a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5m3 0a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0v-4a.5.5 0 0 1 .5-.5M13 5a1 1 0 0 1 1 1v1h3.5a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1H10V6a1 1 0 0 1 1-1zm-2 2h2V6h-2z"
		})
	});
});
//#endregion
export { Icon24Trash };

//# sourceMappingURL=icon-24-trash.js.map